import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8000";

// Async thunk to fetch pet images
export const fetchImagesByPet = createAsyncThunk(
  "images/fetchImagesByPet",
  async (activePet, { rejectWithValue }) => {
    try {
      if (!activePet?.name) {
        return rejectWithValue("No active pet selected");
      }
      const resp = await axios.get(`${API_BASE}/getimages/${activePet.name}`);
      return resp.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const imageSlice = createSlice({
  name: "images",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearImages: (state) => {
      state.data = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchImagesByPet.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchImagesByPet.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchImagesByPet.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearImages } = imageSlice.actions;
export default imageSlice.reducer;
